"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Scissors, Star } from "lucide-react";
const teamMembers = [{
  name: "Hasim",
  role: "Oprichter & Master Barber",
  specialty: "Master of Fades",
  experience: "14+ jaar ervaring",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/IMG-20260518-WA0012.jpg"
}, {
  name: "Halil",
  role: "Senior Barber",
  specialty: "Klassieke Herenkapsels",
  experience: "10+ jaar ervaring",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/20260508_125829.jpg"
}, {
  name: "Hakim",
  role: "Barber Specialist",
  specialty: "Baard Styling & Hot Towel",
  experience: "6+ jaar ervaring",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/IMG-20260518-WA0008.jpg"
}];
export default function HetTeamVanProfessionals() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="het-team-van-professionals" className="dark bg-background text-foreground py-24 px-4 sm:px-8 lg:px-16 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {}
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-[1px] w-12 bg-primary"></div>
            <Scissors className="w-5 h-5 text-primary" />
            <div className="h-[1px] w-12 bg-primary"></div>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 tracking-tight">
            Ontmoet Onze <span className="text-primary">Professionals</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            Bij H&E Kappers wordt u geholpen door ervaren vakmannen. Wij combineren traditionele barbertechnieken met de nieuwste trends voor het perfecte resultaat.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 transition-all duration-1000 delay-200 transform ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {teamMembers.map((member, i) => <div key={i} data-index={i} className="group flex flex-col transition-all duration-200 hover:scale-[1.02]">
              {}
              <div className="relative overflow-hidden rounded-sm aspect-[3/4] mb-6 bg-card border border-border group-hover:shadow-[0px_0px_10px_rgba(255,0,0,0.3)] transition-all duration-200">
                <img src={member.image} alt={`Portret van ${member.name}, ${member.role} bij H&E Kappers`} className="w-full h-full object-cover transition-transform duration-700" loading="lazy" />
                
                {}
                <div className="absolute inset-0 bg-background/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-6 text-center backdrop-blur-sm">
                  <Star className="w-8 h-8 text-primary mb-4" />
                  <h4 className="text-2xl font-bold text-primary mb-2 font-serif">
                    {member.specialty}
                  </h4>
                  <div className="w-12 h-[2px] bg-border my-3"></div>
                  <p className="text-foreground font-medium tracking-wide uppercase text-sm">
                    {member.experience}
                  </p>
                </div>
              </div>

              {}
              <div className="text-center px-2">
                <h3 className="text-2xl font-bold mb-1">{member.name}</h3>
                <p className="text-primary font-medium text-sm uppercase tracking-wider">
                  {member.role}
                </p>
              </div>
            </div>)}
        </div>

        {}
        <div className="mt-20 text-center">
          <Button asChild size="lg" className="rounded-sm text-base px-8 py-6 font-bold tracking-wide hover:shadow-[0px_0px_10px_rgba(255,0,0,0.3)] hover:scale-[1.02] transition-all duration-200">
            <Link to="https://salonkee.nl/salon/he-kappers" newTab>
              Maak een afspraak
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}